module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1824754"
    }
  }, [_c('b', [_vm._v("QUICK CREAM OF BROCCOLI SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1825254"
    }
  }, [_c('b', [_c('i', [_vm._v("Frozen vegetables are picked and processed so quickly they often retain more nutrients than fresh ones. Many frozen vegetables are easily transformed into a satisfying soup. If broccoli is not one of your favorites, try one of the variations.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1827154"
    }
  }, [_c('b', [_vm._v("Prep: 5 minutes Cook: 20 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1827654"
    }
  }, [_vm._v("1 tablespoon butter or margarine")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1827954"
    }
  }, [_vm._v("1 medium onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1828254"
    }
  }, [_vm._v("1 package (10 ounces) frozen chopped broccoli")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1828554"
    }
  }, [_vm._v("1 can (14½ ounces) chicken broth or "), _c('br'), _vm._v(" 1¾ cups Chicken Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1830854"
    }
  }, [_vm._v("¼ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1831854"
    }
  }, [_vm._v("⅛ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1832754"
    }
  }, [_vm._v("⅛ teaspoon ground black pepper "), _c('br'), _vm._v(" pinch ground nutmeg "), _c('br'), _vm._v(" pinch ground red pepper (cayenne; optional)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1834354"
    }
  }, [_vm._v("1½ cups milk")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1835454"
    }
  }, [_vm._v("2 teaspoons fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1836054"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 3-quart saucepan, melt butter over medium heat. Add onion and cook, stirring occasionally, until tender, about 5 minutes. Add frozen broccoli, broth, thyme, salt, pepper, nutmeg, and ground red pepper, if using; heat to boiling over high heat. Reduce heat and simmer 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1838354"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Spoon half of mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour into bowl. Repeat with remaining mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1840254"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Return puree to saucepan; stir in milk. Heat through, stirring often (do not boil). Remove from heat and stir in lemon juice. Makes about 3¾ cups or 4 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1843054"
    }
  }, [_vm._v("Each serving: About 130 calories, 6g protein, 12g carbohydrate, 7g total fat (4g saturated), 21mg cholesterol, 594mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1845754"
    }
  }, [_c('b', [_vm._v("QUICK CREAM OF CORN SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1846254"
    }
  }, [_vm._v("Prepare as directed above but substitute "), _c('b', [_vm._v("1 package (10 ounces) frozen whole-kernel corn")]), _vm._v(" for broccoli; if you like, add "), _c('b', [_vm._v("¾ teaspoon chili powder")]), _vm._v(" after cooking onion and cook 30 seconds before adding broth.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1849354"
    }
  }, [_c('b', [_vm._v("QUICK CREAM OF PEA SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1849854"
    }
  }, [_vm._v("Prepare as directed but substitute "), _c('b', [_vm._v("1 package (10 ounces) frozen peas")]), _vm._v(" for broccoli; if you like, add "), _c('b', [_vm._v("¼ teaspoon dried mint leaves")]), _vm._v(" with broth.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1852854"
    }
  }, [_c('b', [_vm._v("QUICK CREAM OF ASPARAGUS SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1853454"
    }
  }, [_vm._v("Prepare as directed but substitute "), _c('b', [_vm._v("1 package (10 ounces) frozen asparagus")]), _vm._v(" for broccoli; if you like, add "), _c('b', [_vm._v("¼ teaspoon dried tarragon")]), _vm._v(" with broth.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c004c848","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c49_r1.vue
// module id = 213
// module chunks = 0